import uniqBy from 'lodash/uniqBy';

import api from '../REST/api';

// eslint-disable-next-line import/prefer-default-export
export function getUniqueMerchants(name) {
  // there can be several merchant objects with different merchantIds and the same name.
  return api.getZMSAMMerchants().then(merchants =>
    uniqBy(merchants, 'name').map(item => ({
      id: name !== 'merchantName' ? item.id : item.name,
      name: item.name,
    })),
  );
}
